// src/utils/Api.js

import axios from "axios";

/**
 * Retourne un message utilisateur selon l'erreur Axios
 */
function getUserFriendlyErrorMessage(error) {
  // Pas de réponse serveur
  if (!error.response) {
    return "Impossible de joindre le serveur.";
  }

  const status = error.response.status;

  switch (status) {
    case 400:
      return "Requête invalide.";

    case 401:
      return "Vous devez vous connecter.";

    case 403:
      return "Accès refusé.";

    case 404:
      return "Ressource introuvable.";

    case 422:
      return "Les données envoyées sont invalides.";

    case 429:
      return "Trop de requêtes. Réessayez plus tard.";

    case 500:
      return "Erreur interne du serveur.";

    case 503:
      return "Service temporairement indisponible.";

    default:
      return "Une erreur est survenue.";
  }
}

/**
 * Détermine l'URL de base pour l'API Laravel
 */
function getApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_LARAVEL_API_URL;

  if (
    typeof configuredUrl === "string" &&
    configuredUrl.trim() !== ""
  ) {
    return configuredUrl;
  }

  return "/api";
}

/**
 * Instance Axios principale
 */
const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

/**
 * Intercepteur des requêtes
 */
axiosInstance.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem("token");

    // Ajoute automatiquement le token si présent
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    error.userFriendlyMessage =
      getUserFriendlyErrorMessage(error);

    return Promise.reject(error);
  }
);

/**
 * Intercepteur des réponses
 */
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const statusCode = error?.response?.status;
    const message = error?.response?.data?.message;

    /**
     * Token invalide ou expiré
     */
    if (
      statusCode === 401 &&
      message === "Unauthenticated."
    ) {
      sessionStorage.removeItem("token");

      delete axiosInstance.defaults.headers.common.Authorization;
    }

    error.userFriendlyMessage =
      getUserFriendlyErrorMessage(error);

    return Promise.reject(error);
  }
);

/**
 * Retourne le lien complet d'une ressource/image
 */
export function getResource(image) {
  if (
    typeof image !== "string" ||
    image.trim() === ""
  ) {
    return undefined;
  }

  const resourceBaseUrl =
    process.env.REACT_APP_LARAVEL_RESOURCE_URL;

  if (
    !resourceBaseUrl ||
    resourceBaseUrl.trim() === ""
  ) {
    return image;
  }

  return `${resourceBaseUrl.replace(/\/$/, "")}/${image.replace(
    /^\//,
    ""
  )}`;
}

export default axiosInstance;